import React from 'react';
import { SectionHeader } from './SectionHeader';
import { PlusButton } from './PlusButton';
import { MpuAdBox } from './MpuAdBox';
const PLAY_BUTTON_SVG = 'https://cdn.magicpatterns.com/uploads/oy8QapkJ5YySfwfFaQ2ktA/Polygon_4.svg';
const HALFPAGE_AD = 'https://cdn.magicpatterns.com/uploads/dheh7MRLfcpuHSbkGWM9re/Leaderboard_728x90.jpg';
const videos = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/gCovGkvGP2pLsXCUPyT9f3/Rectangle_79.jpg',
  title: 'Gandhi'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/6wFwDnxaBgRxLPRzqTstuT/Rectangle_163.jpg',
  title: 'The Most Interesting Man'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/rJ7H8rjsG9GrTgFXJDBVrC/Rectangle_165.jpg',
  title: 'Man on Couch'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/t9tiicbrByofpF97Aezhej/Rectangle_166.jpg',
  title: 'Jungle Explorer'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/qCL4xsxvX8S9rAXfjoRasB/Rectangle_164.jpg',
  title: '1984 Apple'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/qbBxaukJxXn2n7msxi5JK7/Rectangle_162.jpg',
  title: 'Classic Ad'
}];
export function IconicSection() {
  return <section className="site-container" style={{
    marginTop: '60px',
    marginBottom: '60px'
  }} data-id="element-169">
      {/* Content: grid + plus + ad */}
      <div className="relative flex flex-col lg:flex-row items-start" style={{
      gap: '37.5px'
    }} data-id="element-170">
        {/* LEFT: 2×3 video grid */}
        <div className="w-full lg:flex-1 lg:min-w-0" data-id="element-171">
          {/* ICONIC badge — centered over grid like ArticleRow */}
          <SectionHeader label="Iconic" data-id="element-172" />
          <div className="relative -mt-4" data-id="element-173">
            <div className="grid grid-cols-2 md:grid-cols-3" style={{
            gap: '37.5px'
          }} data-id="element-174">
              {videos.map((video, idx) => <div key={idx} className="relative cursor-pointer group" style={{
              aspectRatio: '1/1',
              borderRadius: '18.75px',
              overflow: 'hidden'
            }} data-id="element-175">
                  <img src={video.imageUrl} alt={video.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" draggable={false} data-id="element-176" />
                  <div className="absolute inset-0 flex items-center justify-center z-10" data-id="element-177">
                    <img src={PLAY_BUTTON_SVG} alt="Play" className="w-[40px] h-[40px] lg:w-[75px] lg:h-[75px]" draggable={false} data-id="element-178" />
                  </div>
                </div>)}
            </div>
            {/* Plus circle — overlapping between row 1 and row 2, right edge */}
            <div className="absolute hidden md:flex items-center justify-center z-20" style={{
            right: '-37.5px',
            top: '50%',
            transform: 'translateY(-50%)'
          }} data-id="element-179">
              <PlusButton size="lg" data-id="element-180" />
            </div>
          </div>
        </div>

        {/* RIGHT: Half-page ad (300×600) */}
        <MpuAdBox src={HALFPAGE_AD} imgHeight="600px" className="flex-shrink-0 lg:self-start mx-auto lg:mx-0 mt-[16px]" data-id="element-181" />
      </div>
    </section>;
}